import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import {translate} from '../../helpers/base';

const Pagination = ({ totalPages, currentPage, maxPagesToShow = 6 }) => {
    const { handlePageChange, isMobile } = useContext(AppContext);

    const handlePrevPage = () => {
        if (currentPage > 1) {
            handlePageChange(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            handlePageChange(currentPage + 1);
        }
    };

    const getPages = () => {
        let startPage = 1;
        let endPage = totalPages;
        const pages = [];

        if (totalPages > maxPagesToShow) {
            const midPoint = Math.floor(maxPagesToShow / 2);

            if (currentPage <= midPoint) {
                startPage = 1;
                endPage = maxPagesToShow - 2;
            } else if (currentPage >= totalPages - midPoint) {
                startPage = totalPages - (maxPagesToShow - 2);
                endPage = totalPages;
            } else {
                startPage = currentPage - midPoint + 1;
                endPage = currentPage + midPoint - 1;
            }

            if (startPage > 1) {
                pages.push(1);
                if (startPage > 2) {
                    pages.push('ellipsis');
                }
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        if (endPage < totalPages - 1) {
            pages.push('ellipsis');
        }

        if (endPage < totalPages) {
            pages.push(totalPages);
        }

        return pages;
    };

    const renderPageButtons = () => {
        return getPages().map((page, index) => (
            <li key={index} className={`page-item ${page === currentPage ? 'active' : ''}`} aria-current={page === currentPage ? 'page' : undefined}>
                {page === 'ellipsis' ? (
                    <span className="page-ellipsis">...</span>
                ) : page === currentPage ? (
                    <button className="page-link" disabled={true}>{page}</button>
                ) : (
                    <button className="page-link" onClick={() => handlePageChange(page)}>{page}</button>
                )}
            </li>
        ));
    };

    const renderPrevButton = () => (
        <button
            className="btn btn-outline btn-sm"
            onClick={handlePrevPage}
            tabIndex={0}
            disabled={currentPage === 1}
        >
            {translate('accommodation-overview.pagination.prev')}
        </button>
    );

    const renderNextButton = () => (
        <button
            className="btn btn-outline btn-sm"
            onClick={handleNextPage}
            tabIndex={0}
            disabled={currentPage === totalPages}
        >
            {translate('accommodation-overview.pagination.next')}
        </button>
    );

    const renderPrevIconButton = () => (
        <li className="page-item">
            <button type="button" className="page-link prev" onClick={handlePrevPage} disabled={currentPage === 1}>
                <i className="icon icon--diverses-chevron-left">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                        <path d="M34.5 239L228.9 44.7c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9L131.5 256l154 154.8c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0L34.5 273c-9.4-9.4-9.4-24.6 0-33.9z"/>
                    </svg>
                </i>
            </button>
        </li>
    );

    const renderNextIconButton = () => (
        <li className="page-item">
            <button type="button" className="page-link next" onClick={handleNextPage} disabled={currentPage === totalPages}>
                <i className="icon icon--diverses-chevron-right">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                        <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/>
                    </svg>
                </i>
            </button>
        </li>
    );

    return (
        <>
            {isMobile ? (
                <>
                    <ul className="pagination">
                        {renderPrevIconButton()}
                        <li className="page-item">
                            <span className="page-ellipsis">{translate('accommodation-overview.pagination.page', {current: currentPage, total: totalPages})}</span>
                        </li>
                        {renderNextIconButton()}
                    </ul>
                </>
            ) : (
                <>
                    {renderPrevButton()}
                    <ul className="pagination">
                        {renderPageButtons()}
                    </ul>
                    {renderNextButton()}
                </>
            )}
        </>
    );
};

export default Pagination;